import moment from 'moment';

const sanitizeCoach = (coachName) => (coachName || 'coach')
  .replace(/[^a-zA-Z0-9-]/g, '-')
  .replace(/-+/g, '-')
  .replace(/^-|-$/g, '')
  .toLowerCase() || 'coach';

export const generateCampaignName = (coachName, when = new Date()) => {
  const slug = sanitizeCoach(coachName);
  const timestamp = moment(when).format('YYYY-MM-DD-HH-mm');
  return `${slug}-${timestamp}`;
};
